var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
import { inject } from "tsyringe";
import { IdMap } from "../../collections";
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { ExtraFeeTypes } from "../Menu";
import { Price } from "../Price";
let ModifierItemInstancePriceService = class ModifierItemInstancePriceService {
    constructor(extraFeeTypes) {
        this.extraFeeTypes = extraFeeTypes;
        makeImmutable(this);
    }
    price(modifierItemInstance, parameterScope) {
        return this.unitPrice(modifierItemInstance, parameterScope);
    }
    unitPrice(modifierItemInstance, parameterScope) {
        const basePrice = Price.scoped(modifierItemInstance.modifierItemType.pricing, parameterScope);
        if (modifierItemInstance.modifierItemPackagingFeeId === null) {
            return basePrice;
        }
        const feeType = this.extraFeeTypes.find(modifierItemInstance.modifierItemPackagingFeeId);
        if (feeType === null) {
            return basePrice;
        }
        return basePrice.add(Price.unscoped(feeType.price));
    }
    defaultPrice(modifierItemInstance, parameterScope) {
        return this.unitPrice(modifierItemInstance, parameterScope).multiply(modifierItemInstance.defaultQuantity);
    }
};
ModifierItemInstancePriceService = __decorate([
    perRestaurant(),
    __param(0, inject(ExtraFeeTypes)),
    __metadata("design:paramtypes", [typeof (_a = typeof IdMap !== "undefined" && IdMap) === "function" ? _a : Object])
], ModifierItemInstancePriceService);
export { ModifierItemInstancePriceService };
